import { render } from "./LabdaqCompletedOrders.vue?vue&type=template&id=af474646"
import script from "./LabdaqCompletedOrders.vue?vue&type=script&lang=js"
export * from "./LabdaqCompletedOrders.vue?vue&type=script&lang=js"

import "./LabdaqCompletedOrders.vue?vue&type=style&index=0&id=af474646&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/cases/LabdaqCompletedOrders.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "af474646"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('af474646', __exports__)) {
    console.log('reload')
    api.reload('af474646', __exports__)
  }
  
  module.hot.accept("./LabdaqCompletedOrders.vue?vue&type=template&id=af474646", () => {
    console.log('re-render')
    api.rerender('af474646', render)
  })

}


export default __exports__